import LocalScheme from '@nuxtjs/auth/lib/schemes/local';
import { STATUSES } from '~/utils/dictionaries';

export default class CustomScheme extends LocalScheme {
	// eslint-disable-next-line no-underscore-dangle
	_setToken(token) {
		if (this.options.globalToken) {
		// Set Authorization token for all axios requests
			this.$auth.ctx.app.$api.axios.setHeader(this.options.tokenName, token);
			this.$auth.ctx.app.$pagesApi.axios.setHeader(this.options.tokenName, token);
		}
	}

	// eslint-disable-next-line no-underscore-dangle
	_clearToken() {
		if (this.options.globalToken) {
		// Clear Authorization token for all axios requests
			this.$auth.ctx.app.$api.axios.setHeader(this.options.tokenName, false);
			this.$auth.ctx.app.$pagesApi.axios.setHeader(this.options.tokenName, false);
		}
	}

	async login(endpoint, rest = {}) {
		if (!this.options.endpoints.login) {
			return null;
		}
		const { scenario } = rest;

		// Ditch any leftover local tokens before attempting to log in
		await this.$auth.reset();

		const { response, result: tokens } = await this.$auth.request(
			endpoint,
			this.options.endpoints.login,
			true,
		);

		if (this.options.tokenRequired) {
			const accessToken = tokens.access_token;
			const refreshToken = tokens.refresh_token;
			const tokenType = tokens.token_type || this.options.tokenType;

			const token = tokenType
				? `${tokenType} ${accessToken}`
				: accessToken;

			this.$auth.setToken(this.name, token);
			// eslint-disable-next-line no-underscore-dangle
			this._setToken(token);
			this.$auth.setRefreshToken(this.name, refreshToken);

			if (scenario) {
				const oldRedirect = this.$auth.options.redirect;
				this.$auth.options.redirect = false;
				this.$auth.options.rewriteRedirects = oldRedirect;
			}
		}

		this.$auth.setUser(response.data.data);

		return response;
	}

	async fetchUser(endpoint) {
		// Token is required but not available
		if (this.options.tokenRequired && !this.$auth.getToken(this.name)) {
			return;
		}

		// User endpoint is disabled.
		if (!this.options.endpoints.user) {
			this.$auth.setUser({});
			return;
		}

		// Try to fetch user and then set
		try {
			const user = await this.$auth.requestWith(
				this.name,
				endpoint,
				this.options.endpoints.user,
			);
			this.$auth.setUser(user);
		} catch (error) {
			const { response } = error;
			if (response) {
				const { status } = response;
				if (status === STATUSES.UNAUTHORIZED) {
					this.$auth.setToken(this.name, false);
					return;
				}
			}
			throw error;
		}
	}
}
